import PreviewJobSeeker from "@Organism/Home/JobSeekers/PreviewJobSeeker";
import LoadingAnimationPage from "@Organism/LoadingAnimationPage";
import AsyncErrorBoundary from "@Organism/Utils/AsyncErrorBoundary";
import { getDetailJobPostForCandidate } from "@Services/client/jobSeeker";
import { listLocationProfile, profileSync } from "@Services/home";
import { Suspense } from "react";
import { Await, defer, useLoaderData } from "react-router-dom";

export const loaderPreviewJobSeeker = (route) => {
  const { id } = route?.params;

  return defer({
    getDetailJobPostForCandidate: getDetailJobPostForCandidate(id),
    getListDropdown: profileSync(),
    getListLocation: listLocationProfile(),
  });
};

export default function PreviewJobSeekerPage() {
  const { getDetailJobPostForCandidate, getListDropdown, getListLocation } =
    useLoaderData();
  return (
    <Suspense
      fallback={
        <div>
          <LoadingAnimationPage />
        </div>
      }
    >
      <Await
        resolve={getDetailJobPostForCandidate}
        errorElement={
          <div style={{ height: "calc(100vh - 220px)" }}>
            <AsyncErrorBoundary />
          </div>
        }
      >
        {(getDetailJobPostForCandidate) => (
          <Suspense
            fallback={
              <div>
                <LoadingAnimationPage />
              </div>
            }
          >
            <Await
              resolve={getListDropdown}
              errorElement={
                <div style={{ height: "calc(100vh - 220px)" }}>
                  <AsyncErrorBoundary />
                </div>
              }
            >
              {(getListDropdown) => (
                <Suspense
                  fallback={
                    <div>
                      <LoadingAnimationPage />
                    </div>
                  }
                >
                  <Await
                    resolve={getListLocation}
                    errorElement={
                      <div style={{ height: "calc(100vh - 220px)" }}>
                        <AsyncErrorBoundary />
                      </div>
                    }
                  >
                    {(getListLocation) => (
                      <PreviewJobSeeker
                        data={getDetailJobPostForCandidate}
                        getListDropdown={getListDropdown?.response}
                        getListLocation={getListLocation?.response}
                      />
                    )}
                  </Await>
                </Suspense>
              )}
            </Await>
          </Suspense>
        )}
      </Await>
    </Suspense>
  );
}
